<template>
    <div class="date-picker-container">

        <div class="line">
            <div class="filter-btn" @click="clearDate()">清除筛选日期</div>
            <!-- 输入触发区域 -->
            <div class="date-input-group">

                <div class="date-input-wrapper">
                    <div class="date-input" @click="startPick()">
                        <i class="el-icon-date" style="margin-right: .2rem;"></i> 
                        <input class="dateinput" type="text" v-model="startYear" maxlength="4" @input="onStartYearInput" placeholder="" style="width: 2rem;" ref="startYearInput" />
                        <span>/年</span>
                        <input class="dateinput" type="text" v-model="startMonth" maxlength="2" @input="onStartMonthInput" placeholder="" ref="startMonthInput" />
                        <span>/月</span>
                        <input class="dateinput" type="text" v-model="startDay" maxlength="2" @input="onStartDayInput" placeholder="" ref="startDayInput" />
                        <span>/日</span>
                        <i v-if="startDate" class="el-icon-close" @click.stop="clearStartDate"></i>
                    </div>

                    <!-- 开始日期选择器 -->
                    <div v-if="showStartPicker" class="calendar-panel">
                        <div class="calendar-header">
                            <button class="prev-month" @click="prevMonth('start')"><i class="el-icon-arrow-left"></i></button>
                            <span>{{ startDisplayYear }}年{{ startDisplayMonth + 1 }}月</span>
                            <button class="prev-month" @click="nextMonth('start')"><i class="el-icon-arrow-right"></i></button>
                        </div>
                        <div class="calendar-grid">
                            <div v-for="day in weekDays" :key="day" class="week-day">{{ day }}</div>
                            <div v-for="(date, index) in startCalendar" :key="index" class="calendar-day" :class="{
                                'other-month': !date.isCurrentMonth,
                                'selected': isStartSelected(date),
                                'in-range': isInRange(date),
                                'disabled': isDisabled(date, 'start')
                            }" @click="selectStartDate(date)">
                                {{ date.day }}
                            </div>
                        </div>
                    </div>
                </div>

                <span class="separator">—</span>

                <div class="date-input-wrapper">
                    <div class="date-input" @click="endPick()">
                        <i class="el-icon-date" style="margin-right: .2rem;"></i> 

                        <input class="dateinput" type="text" v-model="endYear" maxlength="4" @input="onEndYearInput" placeholder=""  style="width: 2rem;" ref="endYearInput" />
                        <span>/年</span>
                        <input class="dateinput" type="text" v-model="endMonth" maxlength="2" @input="onEndMonthInput" placeholder="" ref="endMonthInput" />
                        <span>/月</span>
                        <input class="dateinput" type="text" v-model="endDay" maxlength="2" @input="onEndDayInput" placeholder="" ref="endDayInput" />
                        <span>/日</span>

                        <i class="el-icon-close"  v-if="endDate" @click.stop="clearEndDate"></i>
                    </div>

                    <!-- 结束日期选择器 -->
                    <div v-if="showEndPicker" class="calendar-panel end" style="">
                        <div class="calendar-header">
                            <button class="prev-month" @click="prevMonth('end')"><i class="el-icon-arrow-left"></i></button>
                            <span>{{ endDisplayYear }}年{{ endDisplayMonth + 1 }}月</span>
                            <button class="prev-month" @click="nextMonth('end')"><i class="el-icon-arrow-right"></i></button>
                        </div>
                        <div class="calendar-grid">
                            <div v-for="day in weekDays" :key="day" class="week-day">{{ day }}</div>
                            <div v-for="(date, index) in endCalendar" :key="index" class="calendar-day" :class="{
                                'other-month': !date.isCurrentMonth,
                                'selected': isEndSelected(date),
                                'in-range': isInRange(date),
                                'disabled': isDisabled(date, 'end')
                            }" @click="selectEndDate(date)">
                                {{ date.day }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <div class="filter-btn2" @click="filterDate">筛选日期范围</div>
        </div>

        

        <!-- 操作按钮 -->
        <div v-if="showStartPicker || showEndPicker" class="calendar-footer">
            <!-- <button class="confirm-btn" @click="confirmSelection">确定</button> -->
            <!-- <button class="cancel-btn" @click="cancelSelection">取消</button> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'VisualDatePicker',
    data() {
        return {
            startDate: '',
            endDate: '',
            startYear: '',
            startMonth: '',
            startDay: '',
            endYear: '',
            endMonth: '',
            endDay: '',
            showStartPicker: false,
            showEndPicker: false,
            startDisplayMonth: new Date().getMonth(),
            startDisplayYear: new Date().getFullYear(),
            endDisplayMonth: new Date().getMonth(),
            endDisplayYear: new Date().getFullYear(),
            weekDays: ['日', '一', '二', '三', '四', '五', '六']
        };
    },
    computed: {
        startCalendar() {
            return this.generateCalendar(this.startDisplayYear, this.startDisplayMonth);
        },
        endCalendar() {
            return this.generateCalendar(this.endDisplayYear, this.endDisplayMonth);
        }
    },
    watch: {
        startDate(newVal) {
            this.$emit('date-selected', {
                start: this.startDate,
                end: this.endDate
            })
        },
        endDate(newVal) {
            this.$emit('date-selected', {
                start: this.startDate,
                end: this.endDate
            })
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
    },
    methods: {  
        // 限制年份不超过 9999
        onStartYearInput() {
            this.startYear = this.startYear.replace(/\D/g, '').slice(0, 4);
            if (parseInt(this.startYear) > 9999) {
                this.startYear = '9999'
            }
            if (this.startYear.length === 4) {
                this.$nextTick(() => {
                    this.$refs.startMonthInput?.focus()
                })
            }
            this.onStartPartsInput()
        },

        // 限制月份不超过 12
        onStartMonthInput() {
            this.startMonth = this.startMonth.replace(/\D/g, '').slice(0, 2);
            const num = parseInt(this.startMonth)
            if (num > 12) this.startMonth = '12'

            if (this.startMonth.length === 2) {
                this.$nextTick(() => {
                    this.$refs.startDayInput?.focus()
                })
            }
            this.onStartPartsInput()
        },

        // 限制日期不超过 31
        onStartDayInput() {
            this.startDay = this.startDay.replace(/\D/g, '').slice(0, 2);
            const num = parseInt(this.startDay)
            if (num > 31) this.startDay = '31'
            this.onStartPartsInput()
            this.showStartPicker = false
            this.showEndPicker= false
        },

        // 原有拆分组合逻辑
        onStartPartsInput() {
            if (
                this.startYear.length === 4 &&
                this.startMonth.length >= 1 &&
                this.startDay.length >= 1
            ) {
            const yyyy = this.startYear;
            const mm = this.startMonth.padStart(2, '0')
            const dd = this.startDay.padStart(2, '0')

            const newDate = `${yyyy}-${mm}-${dd}`
            if (this.isValidDate(newDate)) {
                this.startDate = newDate

                if (this.endDate && new Date(this.startDate) > new Date(this.endDate)) {
                    alert('开始日期不能晚于结束日期')
                    this.startDate = ''
                    return;
                }

                this.$emit('date-selected', {
                    start: this.startDate,
                    end: this.endDate
                })
            }
            }
        },

          // 限制年份不超过 9999
        onEndYearInput() {
            this.endYear = this.endYear.replace(/\D/g, '').slice(0, 4);
            if (parseInt(this.endYear) > 9999) {
                this.endYear = '9999'
            }

            if (this.endYear.length === 4) {
                this.$nextTick(() => {
                    this.$refs.endMonthInput?.focus()
                })
            }

            this.onEndPartsInput()
        },

        // 限制月份不超过 12
        onEndMonthInput() {
            this.endMonth = this.endMonth.replace(/\D/g, '').slice(0, 2);
            const num = parseInt(this.endMonth)
            if (num > 12) this.endMonth = '12'

            if (this.endMonth.length === 2) {
                this.$nextTick(() => {
                    this.$refs.endDayInput?.focus()
                })
            }

            this.onEndPartsInput()
        },

        // 限制日期不超过 31
        onEndDayInput() {
            this.endDay = this.endDay.replace(/\D/g, '').slice(0, 2)
            const num = parseInt(this.endDay)
            if (num > 31) this.endDay = '31'
            this.onEndPartsInput()
            this.showStartPicker= false
            this.showEndPicker= false
        },

        onEndPartsInput() {
            if (this.endYear.length === 4 && this.endMonth.length >= 1 && this.endDay.length >= 1) {
                const yyyy = this.endYear
                const mm = this.endMonth.padStart(2, '0')
                const dd = this.endDay.padStart(2, '0')

                const newDate = `${yyyy}-${mm}-${dd}`;
                if (this.isValidDate(newDate)) {
                    this.endDate = newDate

                    console.log( this.endDate, 'endDate')
                    this.$emit('date-selected', {
                        start: this.startDate,
                        end: this.endDate
                    })
                }
            }
        },

        isValidDate(dateStr) {
            const date = new Date(dateStr);
            return !isNaN(date.getTime()) && dateStr.match(/^\d{4}-\d{2}-\d{2}$/);
        },
        startPick() {
            this.showStartPicker = true
            this.showEndPicker = false
        },
        endPick() {
            this.showStartPicker = false
            this.showEndPicker = true
        },
        handleOutsideClick(e) {
            if (!this.$el.contains(e.target)) {
                this.cancelSelection();
            }
        },
        generateCalendar(year, month) {
            const calendar = []
            const firstDay = new Date(year, month, 1)
            const lastDay = new Date(year, month + 1, 0)

            // 填充上月日期
            const prevMonthLastDay = new Date(year, month, 0).getDate()
            const firstDayWeek = firstDay.getDay();
            for (let i = firstDayWeek - 1; i >= 0; i--) {
                calendar.push({
                    day: prevMonthLastDay - i,
                    date: new Date(year, month - 1, prevMonthLastDay - i),
                    isCurrentMonth: false
                });
            }

            // 填充当月日期
            for (let day = 1; day <= lastDay.getDate(); day++) {
                calendar.push({
                    day,
                    date: new Date(year, month, day),
                    isCurrentMonth: true
                });
            }

            // 填充下月日期
            const nextMonthDays = 42 - calendar.length; // 保持6行
            for (let day = 1; day <= nextMonthDays; day++) {
                calendar.push({
                    day,
                    date: new Date(year, month + 1, day),
                    isCurrentMonth: false
                });
            }

            return calendar;
        },

        selectStartDate(date) {
            if (this.isDisabled(date, 'start')) return

            const fullDate = this.formatDate(date.date)
            this.startDate = fullDate;

            // 🧩 新增：同步拆分赋值
            const [yyyy, mm, dd] = fullDate.split('-')
            this.startYear = yyyy
            this.startMonth = mm
            this.startDay = dd

            if (this.endDate && date.date > new Date(this.endDate)) {
                this.endDate = ''
            }
            this.showStartPicker = false
            this.showEndPicker = true

            if (this.endDate) {
                this.confirmSelection()
            }
        },

        selectEndDate(date) {
            if (this.isDisabled(date, 'end')) return;

            const fullDate = this.formatDate(date.date)
            this.endDate = fullDate

            // 🧩 新增：同步拆分赋值
            const [yyyy, mm, dd] = fullDate.split('-')
            this.endYear = yyyy
            this.endMonth = mm
            this.endDay = dd

            if (date.date < new Date(this.startDate)) {
                alert('结束日期不能早于开始日期')
                return
            }
            this.endDate = this.formatDate(date.date);
            this.showEndPicker = false;

            // 如果开始日期也有了，就自动确认
            if (this.startDate) {
                this.confirmSelection();
            }
        },

        isStartSelected(date) {
            return this.formatDate(date.date) === this.startDate;
        },

        isEndSelected(date) {
            return this.formatDate(date.date) === this.endDate;
        },

        isInRange(date) {
            if (!this.startDate || !this.endDate) return false;
            const current = date.date;
            return current >= new Date(this.startDate) && current <= new Date(this.endDate);
        },

        isDisabled(date, type) {
            const current = date.date;
            if (type === 'start') {
                return current > new Date() || (this.endDate && current > new Date(this.endDate));
            }
            return current < new Date(this.startDate) || current > new Date();
        },

        formatDate(date) {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            // return `${yyyy}年${mm}月${dd}日`;
            return `${yyyy}-${mm}-${dd}`;
        },

        prevMonth(type) {
            if (type === 'start') {
                if (this.startDisplayMonth === 0) {
                    this.startDisplayYear--;
                    this.startDisplayMonth = 11;
                } else {
                    this.startDisplayMonth--;
                }
            } else {
                if (this.endDisplayMonth === 0) {
                    this.endDisplayYear--;
                    this.endDisplayMonth = 11;
                } else {
                    this.endDisplayMonth--;
                }
            }
        },

        nextMonth(type) {
            if (type === 'start') {
                if (this.startDisplayMonth === 11) {
                    this.startDisplayYear++;
                    this.startDisplayMonth = 0;
                } else {
                    this.startDisplayMonth++;
                }
            } else {
                if (this.endDisplayMonth === 11) {
                    this.endDisplayYear++;
                    this.endDisplayMonth = 0;
                } else {
                    this.endDisplayMonth++;
                }
            }
        },
        clearDate() {
            this.endDate = ''
            this.startDate = ''
            this.startYear= '',
            this.startMonth= '',
            this.startDay= '',
            this.endYear= '',
            this.endMonth= '',
            this.endDay= '',
            this.$emit('date-selected', {
                start: this.startDate,
                end: this.endDate
            })
        },
        clearStartDate() {
            this.startYear = ''
            this.startMonth = ''
            this.startDay = ''
            this.startDate = ''
            this.$emit('date-selected', {
                start: this.startDate,
                end: this.endDate
            });
        },
        filterDate() {
            this.$emit('search')
        },
        clearEndDate() {
            this.endDate = ''
            this.endYear = ''
            this.endMonth = ''
            this.endDay = ''
        },
        confirmSelection() {
            if (this.startDate && this.endDate) {
                this.$emit('date-selected', {
                    start: this.startDate,
                    end: this.endDate
                })
                this.showStartPicker = false;
                this.showEndPicker = false;
            }
        },
        cancelSelection() {
            this.showStartPicker = false;
            this.showEndPicker = false;
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
    },
};
</script>

<style scoped>


.dateinput {
  width: 1.5rem;
  padding: 0.1rem 0rem;
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  font-size: .8rem;
}


.date-picker-container {
    position: relative;
    max-width: 600px;
    font-family: Arial, sans-serif;
}

.date-input-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.date-input {
    position: relative;
    padding: .2rem .6rem .2rem .3rem;
    /* border: .1rem solid #74c8a3; */
    border-radius: 4px;
    cursor: pointer;
    min-width: 12.2rem;
    box-sizing: border-box;
    height: 1.5rem;
    display: flex;
    align-items: center;
    font-size: .8rem;
}

.date-input:hover {
    border-color: #5aa986;
}

.el-icon-close {
    font-size: 1rem;
}

.clear-icon:hover {
    color: #666;
}

.calendar-panel {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    background: white;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-top: 5px;
}

.date-input-wrapper {
    position: relative;
}

.calendar-panel {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    background: white;
    width: max-content;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-top: 5px;
}

.calendar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding: 0 10px;
}

.calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
}

.week-day {
    text-align: center;
    padding: 5px;
    color: #666;
    font-size: 0.9em;
}

.calendar-day {
    padding: 8px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
}

.calendar-day:hover:not(.disabled) {
    background: #f0f0f0;
}

.selected {
    background: #74c8a3 !important;
    color: white;
}

.in-range {
    background: #e6f4ec;
}

.disabled {
    color: #ccc;
    cursor: not-allowed;
}

.other-month {
    color: #999;
}

.calendar-footer {
    margin-top: 10px;
    text-align: right;
    position: absolute;
    bottom: -2.7rem;
    right: 4.2rem;

}

.confirm-btn {
    background: #74c8a3;
    color: white;
    border: none;
    padding: 6px 15px;
    border-radius: 4px;
    margin-left: 5px;
}

.cancel-btn {
    background: #f0f0f0;
    border: 1px solid #ddd;
    padding: 6px 15px;
    border-radius: 4px;
    cursor: pointer;
}

.prev-month {
    border: .081rem solid #74c8a3;
    box-sizing: border-box;
    border-radius: .2rem;
    background: transparent;
    color: #74c8a3;
    cursor: pointer;
}

.prev-month:hover {
    border: .081rem solid #74c8a3;
    background: #74c8a3;
    color: white;
}

.filter-btn {
  background: #74c8a3;
  padding: 0.2rem 0.4rem;
  border-radius: 0.3rem;
  color: white;
  border: none;
  cursor: pointer;
  transition: background 0.3s;
}

.filter-btn2 {
    background: #74c8a3;
    padding: 0.2rem 0.4rem;
    border-radius: 0.3rem;
    color: white;
    border: none;
    cursor: pointer;
    transition: background 0.3s;
}

.filter-btn:hover {
  background: #5aa986;
}

.line {
    display: flex;
}

@media screen and (max-width: 768px) {
    .line {
        flex-wrap: wrap;
    }

    .filter-btn2 {
        display: none;
    }

    .date-input {
        min-width: 10.2rem
    }

    .dateinput {
        width: 1.2rem;
        padding: 0.1rem 0rem;
        border: none;
        border-bottom: 1px solid #ccc;
        border-radius: 4px;
        text-align: center;
        font-size: .7rem;
    }

}

@media screen and (max-width: 580px) { 
    .calendar-panel.end {
        left: -10vw;
    }
}

@media screen and (max-width: 480px) { 
    .calendar-panel.end {
        left: -28vw;
    }

    .dateinput {
        width: 1.2rem;
        padding: 0.1rem 0rem;
        border: none;
        border-bottom: 1px solid #ccc;
        border-radius: 4px;
        text-align: center;
        font-size: .7rem;
    }

    .date-input {
        position: relative;
        padding: .2rem .1rem .2rem .1rem;
        border-radius: 4px;
        cursor: pointer;
        min-width: 9.8rem;
    }

    .date-input-group {
        display: flex;
        align-items: center;
        gap: 7px;
    }
}
</style>